/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { queryOptions, useQuery, useSuspenseQuery } from '@tanstack/react-query'
import type {
	UseQueryOptions,
	UseQueryResult,
	UseSuspenseQueryOptions,
	UseSuspenseQueryResult,
} from '@tanstack/react-query'
import type { AxiosError, AxiosRequestConfig } from 'axios'
import { googleFontsIndex } from '../../axios/googleFontsIndex'
import type { GoogleFontsIndexError, GoogleFontsIndexResponse } from '../../types/GoogleFontsIndex'

export const googleFontsIndexQueryKey = () => [{ url: '/google-fonts' }] as const

export type GoogleFontsIndexQueryKey = ReturnType<typeof googleFontsIndexQueryKey>

/** @see backend/nexus/modules/System/Http/Controllers/GoogleFontsController.php GoogleFontsController::index */
export function googleFontsIndexQueryOptions(config?: AxiosRequestConfig) {
	return queryOptions<
		GoogleFontsIndexResponse,
		AxiosError<GoogleFontsIndexError>,
		GoogleFontsIndexResponse,
		GoogleFontsIndexQueryKey
	>({
		queryKey: googleFontsIndexQueryKey(),
		queryFn: ({ signal }) => googleFontsIndex({ signal, ...config }).then(res => res.data),
	})
}

/** @see backend/nexus/modules/System/Http/Controllers/GoogleFontsController.php GoogleFontsController::index */
export function useGoogleFontsIndex<TSelectData = GoogleFontsIndexResponse>(
	options?:
		& Partial<
			Omit<
				UseQueryOptions<
					GoogleFontsIndexResponse,
					AxiosError<GoogleFontsIndexError>,
					TSelectData,
					GoogleFontsIndexQueryKey
				>,
				'queryKey' | 'queryFn'
			>
		>
		& { queryKey?: readonly unknown[] },
): UseQueryResult<TSelectData, AxiosError<GoogleFontsIndexError>> {
	const { queryKey: customQueryKey, ...opts } = options ?? {}
	return useQuery({
		...googleFontsIndexQueryOptions(),
		...opts as any,
		...(customQueryKey ? { queryKey: customQueryKey as any } : {}),
	})
}

/** @see backend/nexus/modules/System/Http/Controllers/GoogleFontsController.php GoogleFontsController::index */
export function useGoogleFontsIndexSuspense<TSelectData = GoogleFontsIndexResponse>(
	options?:
		& Partial<
			Omit<
				UseSuspenseQueryOptions<
					GoogleFontsIndexResponse,
					AxiosError<GoogleFontsIndexError>,
					TSelectData,
					GoogleFontsIndexQueryKey
				>,
				'queryKey' | 'queryFn'
			>
		>
		& { queryKey?: readonly unknown[] },
): UseSuspenseQueryResult<TSelectData, AxiosError<GoogleFontsIndexError>> {
	const { queryKey: customQueryKey, ...opts } = options ?? {}
	return useSuspenseQuery({
		...googleFontsIndexQueryOptions(),
		...opts as any,
		...(customQueryKey ? { queryKey: customQueryKey as any } : {}),
	})
}
